
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/vendor-privacy",
      function () {
        return require("private-next-pages/services/vendor-privacy.tsx");
      }
    ]);
  